var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 431,
    viewBox: "0 0 531 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.829 0.690683L255.666 46.0195L272.243 75.9254L230.622 145.35L188.543 144.566L156.838 197.481L106.842 196.552L90.5187 167.105L30.901 165.982L0.250081 217.141L29.2157 269.397L88.8323 270.493L113.623 229.138L168.781 230.165L178.965 248.537L140.492 312.737L92.309 311.844L57.4001 370.093L90.3885 429.606L158.286 430.869L193.205 372.614L168.825 328.633L206.307 266.09L256.421 267.02L278.054 230.92L353.87 232.329L389.936 297.394L482.887 299.117L530.673 219.382L485.512 137.909L392.57 136.18L354.41 199.867L285.672 198.588L262.078 156.022L300.043 92.6644L334.168 93.309L361.33 47.9801L335.664 1.67597L282.829 0.690683ZM293.951 70.1774L281.72 48.1123L293.791 26.9921L318.089 27.9525L330.32 50.0176L318.253 71.1222L293.951 70.1774ZM45.6218 241.241L32.4148 217.415L47.8401 193.297L76.4775 192.99L89.6845 216.816L74.2433 240.93L45.6218 241.241ZM206.414 232.999L192.811 208.458L208.837 181.277L240.371 182.095L253.974 206.636L237.958 233.813L206.414 232.999ZM109.729 403.349L94.1972 375.33L110.212 348.139L141.757 348.967L157.288 376.986L141.274 404.177L109.729 403.349ZM413.917 256.618L392.37 217.746L414.12 180.283L457.415 181.691L478.962 220.563L457.219 258.036L413.917 256.618Z",
    fill: "url(#paint0_linear_0_193)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_193",
    x1: 379.689,
    y1: -53,
    x2: -46.2507,
    y2: 183.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36421,
    stopColor: "#E030CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747241,
    stopColor: "#EA414B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09246"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigIcon);
export default __webpack_public_path__ + "static/media/big_icon.1de36f165cc94337abe71f6a47b6fa62.svg";
export { ForwardRef as ReactComponent };